import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Banner } from '@teamsnap/snap-ui';
import { selectFlashMessage } from 'state/app/selectors';

class FlashMessage extends Component {
  render () {
    const { showFlashMessage, flashMessageProps } = this.props;

    if (!showFlashMessage) { return null; }

    return <Banner { ...flashMessageProps } />;
  }
}

FlashMessage.propTypes = {
  flashMessageProps: PropTypes.shape({}).isRequired,
  showFlashMessage: PropTypes.bool.isRequired
};

const mapDispatchToProps = {};

const mapStateToProps = state => ({
  ...selectFlashMessage(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(FlashMessage);
